import { useEffect, useState } from 'react';
import { Tabs, Space, Table, Input, Badge } from 'antd';
import type { TabsProps } from 'antd';
import { Button, Form, Spin } from 'antd';
import { UserOutlined, ContactsOutlined } from '@ant-design/icons';
import axios from 'axios';
import Tab1 from './Tab1';
import Utilisateur from '../../../Models/Utilisateur';
import { useAuthHeader, useAuthUser } from '../../../Services/Auth/sessionAuth';
import Data from '../../../Data/Data.json';
import SweetAlert from "sweetalert2";
import { Crypter } from '../../../Functions/Security/Crypter';
import { Box, Typography } from '@mui/material';
import Tab2 from './Tab2';
import { ColumnsType } from 'antd/es/table';
import InputForm from '../../InputT';
import DataCpt from '../../../Types/DataCpt';
import ParamsPicklist from '../../../Types/ParamsPicklist';
import SearchInput from '../../SearchInput';
import Tab3 from './Tab3';
import DataProcurationClient from '../../../Types/DataProcurationClient';
import DataRelationClient from '../../../Types/DataRelationClient';
import DataHistoCpt from '../../../Types/DataHistoCpt';
import { HistoCpt } from '../../../Models/HistoCpt';
import { useNavigate } from 'react-router-dom';
import formatNumber from '../../../Functions/Traitement/FormatNumber';
import Tab4 from './Tab4';
import Tab7 from './Tab7';
import DataPeriodAuto from "../../../Functions/Traitement/DataPeriodAuto";
import DataType from '../../../Functions/Traitement/DataPeriodMbloquer';
import DataPeriodMVirement from "../../../Functions/Traitement/DataPeriodMVirement";
import { useParams } from 'react-router-dom';
import Pret from '../../../Models/Pret';
import Tab5 from './Tab5';
import Tab6 from './Tab6';
import { useAgence } from '../../../AgenceContext';
import { PrintHistCompteDirect } from '../../../utilitaires/globalFunction';


const Historique = () => {
  // USER SESSION
  const auth = useAuthUser();
   const Branch=useAgence();
  const user: Utilisateur = JSON.parse(JSON.stringify(auth()));
  // USER TOKEN
  const authHeader = useAuthHeader();
  const param = useParams();

  //input de reacherche
  const { Search } = Input;
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [ActiveForm, SetActiveForm] = useState(false);
  const [DataCpt, setDataCpt] = useState<DataCpt[]>([]);
  const [DataHisto, setDataHisto] = useState<DataHistoCpt[]>([]);
  const [SearchR, SetSearchR] = useState<string>("");
  const [DataSingCpt, SetDataSingCpt] = useState<DataRelationClient[]>([]);
  const [DataProCpt, SetDataProCpt] = useState<DataProcurationClient[]>([]);
  const [Imprimer, SetImprimer] = useState(true);
  const [Consulter, SetConsulter] = useState(false);
  const [Numcpt, SetNumcpt] = useState<string>("");
  const [DataMontantBloque, SetDataMontantBloque] = useState<DataType[]>([]);
  const [start, setstart] = useState<boolean>(false);
  const [dataPret, setDatapret] = useState<Pret[]>([]);
  const [DataPeriodAuto,setDataPeriodAuto]  = useState<DataPeriodAuto[]>([]);
  const [DataPeriodMVirement,setDataPeriodMVirement]= useState<DataPeriodMVirement[]>([]);
 
  const navigate = useNavigate();

  useEffect(() => {
    if (start == false) {
      HandlerChange();
      setstart(true);
    }
    else {
    }
  }, []);


  const HandlerChange = async () => {
    setLoading(true);
    if (param.id !== '0') {form.setFieldValue("NUMCPT", param.id)}
   
    setLoading(false)
  }

  function initialiazeButton() {
    SetImprimer(true);
    SetConsulter(true);
  }

  const column: ColumnsType<DataHistoCpt> = [
    {
      title: 'Date Opération ',
      dataIndex: 'DATOPE',
      align: 'left'
    },
    {
      title: 'Heure',
      dataIndex: 'TIME',
      align: 'left'
    },
    {
      title: 'Date Valeur',
      dataIndex: 'DEDEVR',
      align: 'left'
    },
    {
      title: 'Reference',
      dataIndex: 'REPECE',
      align: 'left'
    },
    {
      title: 'Libelle',
      dataIndex: 'LIBELL',
      align: 'left'
    },
    {
      title: 'Montant Débit',
      dataIndex: 'MONTANTDEBIT',
      align: 'left'
    },
    {
      title: 'Montant Crédit',
      dataIndex: 'MONTANTCREDIT',
      align: 'left'
  
    },
    {
      title: 'Solde Total',
      dataIndex: 'SOLDT',
      align: 'left'
    },
    {
      title: 'Beneficiare',
      dataIndex: 'NBENEF',
      align: 'left'
    }
    // ,
    // {
    //   title: 'Utilisateur',
    //   dataIndex: 'UTISAI',
    //   align: 'left'
    // }
  ];

  const columns: ColumnsType<DataCpt> = [
    {
      title: 'Agence',
      dataIndex: 'AGCCPT',
      align: 'center',
      width: 70,
    },
    {
      title: 'N° Compte',
      dataIndex: 'NUMCPT',
      ellipsis: true,
      width: 200,
      filteredValue: [SearchR],
      onFilter: (value: any, record: any) => {
        return String(record.NUMCPT)
          .toLowerCase()
          .includes(value.toLowerCase()) ||
          String(record.NOMCPT)
            .toLowerCase()
            .includes(value.toLowerCase()) ||
          String(record.DATCRE)
            .toLowerCase()
            .includes(value.toLowerCase()) ||
          String(record.AGCCPT)
            .toLowerCase()
            .includes(value.toLowerCase()) ||
          String(record.SoldeV)
            .toLowerCase()
            .includes(value.toLowerCase()) ||
          String(record.Solde)
            .toLowerCase()
            .includes(value.toLowerCase()) ||
          String(record.DATCRE)
            .toLowerCase()
            .includes(value.toLowerCase()) ||
          String(record.DatMaj)
            .toLowerCase()
            .includes(value.toLowerCase()) ||
          String(record.Etat)
            .toLowerCase()
            .includes(value.toLowerCase())
      }
    },
    {
      title: 'Nom Compte',
      dataIndex: 'NOMCPT',
      ellipsis: true,
      width: 150,
    },
    {
      title: 'Plan Comptable',
      dataIndex: 'TYCPT',
    },
    {
      title: 'Solde  Veille',
      dataIndex: 'SoldeV',
      align:"right"
    },
    {
      title: 'Disponible ',
      dataIndex: 'Solde',
      align:"right"
    },
    {
      title: 'Date Creation',
      dataIndex: 'DATCRE',
    },
    {
      title: 'Date MAJ',
      dataIndex: 'DatMaj',
    },
    {
      title: 'Status',
      dataIndex: 'Etat',
      align: 'center',
      render: (text: any, record: any) => (
        <span>
          <Badge status='success' color={record.Etat == "01" ? '#116599' : record.Etat == "11" ? 'red' : 'orange'} size='default' count={record.Etat == "01" ? 'Actif' : record.Etat == "11" ? 'Dormant' : 'Inatif'}> </Badge>
        </span>)
    },
    {
      title: "",
      dataIndex: 'RelObject',
      width: 1
    }
  ];


  const consult = async () => {
    SetDataProCpt([]);
    SetDataSingCpt([]);
    SetDataMontantBloque([]);
    setDataPeriodAuto([]);
    setDataPeriodMVirement([]);
    setDatapret([]);

    let NUMCPT = Crypter.encrypt(form.getFieldValue('NUMCPT'));
    let Numcli = form.getFieldValue('NUMCLI');
    let Agence = Crypter.encrypt(user.codage);
    setLoading(true);
    
    if (NUMCPT.length !== 0) {
      //configuration pour les informations du compte
      let config1 = {
        method: 'get',
        maxBodyLength: Infinity,
        url: Data.ApiUrl.GetClient,
        headers: {
          'CypherNumcli': Crypter.encrypt(Numcli),
          'Authorization': authHeader(),
          'Content-Type': 'application/json'
        },
      };

      //configuration pour avoir les signataires d'un compte

      let config2 = {
        method: 'get',
        maxBodyLength: Infinity,
        url: Data.ApiUrl.GetSignCpt,
        headers: {
          'CypherNumCpte': NUMCPT,
          'Authorization': authHeader(),
          'Content-Type': 'application/json'
        },
      };

      //configuration pour avoir les procuration d'un compte

      let config3 = {
        method: 'get',
        maxBodyLength: Infinity,
        url: Data.ApiUrl.GetProCpt,
        headers: {
          'CypherNumCpte': NUMCPT,
          'Authorization': authHeader(),
          'Content-Type': 'application/json'
        },
      };

      //configuration pour avoir Montant bloqué sur un compte compte
      let config4 = {
        method: 'get',
        maxBodyLength: Infinity,
        url: Data.ApiUrl.AllReadMontantBloquer,
        headers: {
          'Cyphercodage': Agence,
          'Cyphertrie': NUMCPT,
          'Authorization': authHeader(),
          'Content-Type': 'application/json'
        },
      };

       //configuration pour avoir les prets d'un client 
       let config5 = {
        method: 'get',
        maxBodyLength: Infinity,
        url: Data.ApiUrl.GetDetailClient,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': authHeader(),
          'CypherNumcli':Crypter.encrypt(Numcli),
          'CypherCodu': Crypter.encrypt(user.coduti),
          'CypherAgence': Crypter.encrypt(user.codage),
          'CypherOption': Crypter.encrypt('1')
        },
      };


      let config6 = {
        method: 'get',
        maxBodyLength: Infinity,
        url: Data.ApiUrl.GetDetailClient,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': authHeader(),
          'CypherNumcli':Crypter.encrypt(Numcli),
          'CypherCodu': Crypter.encrypt(user.coduti),
          'CypherAgence': Crypter.encrypt(user.codage),
          'CypherOption': Crypter.encrypt('2')
        },
      };

      let config7 = {
        method: 'get',
        maxBodyLength: Infinity,
        url: Data.ApiUrl.GetDetailClient,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': authHeader(),
          'CypherNumcli':Crypter.encrypt(Numcli),
          'CypherCodu': Crypter.encrypt(user.coduti),
          'CypherAgence': Crypter.encrypt(user.codage),
          'CypherOption': Crypter.encrypt('3')
        },
      };

      let requestOne = axios.request(config1);
      let requestTwo = axios.request(config2);
      let requestTree = axios.request(config3);
      let requestFour = axios.request(config4);
      let requestFive = axios.request(config5);
      let requestSix = axios.request(config6);
      let requestSeven = axios.request(config7);

      await axios
        .all([requestOne, requestTwo, requestTree, requestFour , requestFive,requestSix ,requestSeven])
        .then(
          await axios.spread(async (...responses: any) => {
            const responseOne   = responses[0];
            const responseTwo   = responses[1];
            const responseTree  = responses[2];
            const responseFour  = responses[3];
            const responseFive  = responses[4];
            const responseSix   = responses[5];
            const responseSeven = responses[6];

            if (responseOne.data)
            {
              localStorage.clear();
              const res = JSON.parse(Crypter.decrypt(responseOne.data));
              if (res.StatutCode === 200)
               {
                if (res.Result.Table.length > 0)
                 {
                  form.setFieldsValue(res.Result.Table[0]);
                  SetConsulter(false);
                  SetActiveForm(false);
                }
               }
              }
                  //  setLoading(false);

                  // let dataA: DataType[] = [];
                  let dataP: DataProcurationClient[] = [];
                  // form.setFieldValue('categocpt', datas.categocpt + '-' + datas.lib_categocpt);
                  if (responseTwo.data) 
                  {
                    let datat: DataRelationClient[] = [];
                    const res = JSON.parse(Crypter.decrypt(responseTwo.data));
                    if (res.StatutCode === 200) {
                      if (res.Result.Table.length > 0) {
                        if (typeof res.Result.Table != 'undefined' || "") {
                          res.Result.Table.map((data: any, indice: any) => {
                            datat.push({
                              key: indice,
                              NUMCPT: data.NUMCPT,
                              idclient: data.IdClient,
                              CODEREL: data.CODREL,
                              Nom: data.NomRel,
                              Prenom: data.Prenom,
                              Tel: data.TelRel,
                              filiation: data.lib_filiation,
                              Datecre: data.DatCre ? (new Date(data.DatCre.substring(0, 10))).toLocaleDateString("fr") : '',
                              INSTITULER: data.INSTITULER,
                              RelObject: data,
                              Plafond: data.LIMITE
                            })
                          });
                        }
                      }
                    }if (datat.length > 0) { SetDataSingCpt(datat); }
                  }

                  
                  if (responseTree.data)
                   {
                    const res = JSON.parse(Crypter.decrypt(responseTree.data));
                    if (res.StatutCode === 200) 
                    {
                      let datas = res.Result.Table;
                      if (res.Result.Table.length > 0) {
                        if (typeof res.Result.Table != 'undefined' || "") {
                          // alert(JSON.stringify(datat));
                          datas.map((data: any, indice: any) => {
                            dataP.push({
                              key: indice,
                              NUMCPT: data.NUMCPT,
                              idclient: data.idrel,
                              CODEREL: data.Refprocur,
                              Nom: data.nom,
                              Prenom: data.prenom,
                              Tel: data.TelProcur,
                              ville: data.lieuNais,
                              DateDebut: data.datDebut ? (new Date(data.datDebut.substring(0, 10))).toLocaleDateString("fr") : '',
                              DateFin: data.DatFin ? (new Date(data.DatFin.substring(0, 10))).toLocaleDateString("fr") : '',
                              plafond: data.LIMITE + "  " + "FCFA",
                              filiation: data.filiation + "-" + data.lib_filiation,
                              Datecre: data.datcre ? (new Date(data.datcre.substring(0, 10))).toLocaleDateString("fr") : '',
                              RelObject: data
                            })
                          });
                        }
                        if (dataP.length > 0) { SetDataProCpt(dataP) }
                      }
                    }
                }

              //si y'a la reponse pour le montant bloqué
              //MAPPING DANS LE TABLEAU
             
              if (responseFour.data) 
              {
                const res = responseFour.data;
                let datas = responseFour.data.Result;
                let dat: DataType[] = [];
               
                if (res.StatutCode === 200) {
                  if(datas.length>0){
                  datas.map((val: any, key: any) => {
                    dat.push({
                      key: key,
                      REFMARQ: val.REFMARQ,
                      codage: val.codage,
                      NUMCPT: val.NUMCPT,
                      NOMCPT: val.NOMCPT,
                      MONTPR: val.MONTPR,
                      DISPON: val.DISPON,
                      DATCRE: val.DATCRE ? (new Date(val.DATCRE.substring(0, 10))).toLocaleDateString("fr") : '',
                      DATEFM: val.DATEFM ? (new Date(val.DATEFM.substring(0, 10))).toLocaleDateString("fr") : '',
                      MOTIFM: val.NUMCPT
                    })
                  })
                }
                }
                if (dat.length > 0) { SetDataMontantBloque((dat)) }
               }
             
               
               if (responseFive.data)
              {
                const res = JSON.parse(Crypter.decrypt(responseFive.data)).Value;
                if (res.StatutCode === 200) {
                var datat: Pret[] = [];
                res.Result.map((data: Pret, indice: number) => {
                  datat.push({
                    key: indice,
                    NUMDOS: data.NUMDOS,
                    NUMCLI: data.NUMCLI,
                    NOMCLI: data.NOMCLI,
                    DATEDEM: data.DATEDEM ? (new Date(data.DATEDEM.substring(0, 10))).toLocaleDateString("fr") : '' ,
                    TYPEPRET: data.TYPEPRET,
                    CODGES: data.CODGES,
                    CODNAE: data.CODNAE,
                    MTPRET: data.MTPRET,
                    MOTIFDEM: data.MOTIFDEM,
                    GARANTIE1: data.GARANTIE1,
                    GARANTIE2: data.GARANTIE2,
                    NOMAVAL1: data.NOMAVAL1,
                    NOMAVAL2: data.NOMAVAL2,
                    NOMAVAL3: data.NOMAVAL3,
                    COMMENT: data.COMMENT,
                    CDETAT: data.CDETAT,
                    UTILISAI: data.UTILISAI,
                    CPTENG: data.CPTENG,
                    LETAVC: data.LETAVC,
                    CPTORDI: data.CPTORDI,
                    LETCPT: data.LETCPT,
                    CPTIMP: data.CPTIMP,
                    LETIMP: data.LETIMP,
                    PERIODIC: data.PERIODIC,
                    NBRECHE: data.NBRECHE,
                    TYPCALC: data.TYPCALC,
                    TAUXEPAR: data.TAUXEPAR,
                    TYPAMORT: data.TYPAMORT,
                    TAUXINT: data.TAUXINT,
                    TAUXTAX: data.TAUXTAX,
                    DATEPEN: data.DATEPEN,
                    PRELPEN: data.PRELPEN,
                    DAT1ECHE: data.DAT1ECHE,
                    NBPERDIF: data.NBPERDIF,
                    TAUXPEN: data.TAUXPEN,
                    GESIMPAI: data.GESIMPAI,
                    DATCRE: data.DATCRE,
                    ICTPTX: data.ICTPTX,
                    TXANPR: data.TXANPR,
                    TXCOMM: data.TXCOMM,
                    DATACC: data.DATACC,
                    UTIAPP: data.UTIAPP,
                    ANNUIT: data.ANNUIT,
                    DECOUV: data.DECOUV,
                    PENALI: data.PENALI,
                    UTIVAL: data.UTIVAL,
                    IMAVIS: data.IMAVIS,
                    INTERE: data.INTERE,
                    COMMIS: data.COMMIS,
                    AGCCPT: data.AGCCPT,
                    NBMARR: data.NBMARR,
                    MTIMPA: data.MTIMPA,
                    INIMPA: data.INIMPA,
                    MTREST: data.MTREST,
                    DIFFER: data.DIFFER,
                    NBECHT: data.NBECHT,
                    CDENAE: data.CDENAE,
                    MONTAN: data.MONTAN,
                    CINTIMP: data.CINTIMP,
                    NBFPENEX: data.NBFPENEX,
                    DATECH: data.DATECH,
                    FRAIDOSSIE: data.FRAIDOSSIE,
                    CPTEPARG: data.CPTEPARG,
                    ISPAIEPARG: data.ISPAIEPARG,
                    TAUXEPARG: data.TAUXEPARG,
                    MONTEPARG: data.MONTEPARG,
                    iSEPARGDCR: data.iSEPARGDCR,
                    iSBLOQEPARG: data.iSBLOQEPARG,
                    sEXE: data.sEXE,
                    annee: data.annee,
                    heurVal: data.heurVal,
                    dateVal:  data.dateVal,
                    coteprod: data.coteprod,
                    isGestCrDout: data.isGestCrDout,
                    mntRestant: data.mntRestant,
                    impaye: data.impaye,
                    nummbre: data.nummbre,
                    nommembre: data.nommembre,
                    premembre: data.premembre,
                    numidenti: data.numidenti,
                    cidentite1: data.cidentite1,
                    valgaranti: data.valgaranti,
                    designation: data.designation,
                    typcli: data.typcli,
                    libtypepret: data.libtypepret,
                    fraimember: data.fraimember,
                    libges: data.libges,
                    numcligrp: data.numcligrp,
                    montauto: data.montauto,
                    numdosmembre: data.numdosmembre,
                    fraiservi: data.fraiservi,
                    cptbloq: data.cptbloq,
                    mntdecaisse: data.mntdecaisse,
                    totdecaisse: data.totdecaisse,
                    typeDebloq: data.typeDebloq,
                    isGestAssur: data.isGestAssur,
                    txtAssur: data.txtAssur,
                    fraiDosAssur: data.fraiDosAssur,
                    cptAssur: data.cptAssur,
                    txtEmf: data.txtEmf,
                    cptEmf: data.cptEmf,
                    tvaEmf: data.tvaEmf,
                    cpttvaEmf: data.cpttvaEmf,
                    primeAssur: data.primeAssur,
                    mtFrAssur: data.mtFrAssur,
                    primeEmf: data.primeEmf,
                    mttvaemf: data.mttvaemf,
                    cptPromessOctPret: data.cptPromessOctPret,
                    cptPenImp: data.cptPenImp,
                    cptPenARecev: data.cptPenARecev,
                    cptCrDout: data.cptCrDout,
                    cptIntCrDout: data.cptIntCrDout,
                    cptImoCrDout: data.cptImoCrDout,
                    cptProvCrDout: data.cptProvCrDout,
                    jrConstatImp: data.jrConstatImp,
                    jrConstatDouteux: data.jrConstatDouteux,
                    coduti: data.coduti,
                    INTREST: data.INTREST,
                    TAXREST: data.TAXREST,
                    MNTREST: data.MNTREST,
                    MNTPAYE: data.MNTPAYE,
                    MNTIMPREST: data.MNTIMPREST,
                    iNTPAYE: data.iNTPAYE,
                    iNTIMPREST: data.iNTIMPREST,
                    tAXPAYE: data.tAXPAYE,
                    tAXIMPREST: data.tAXIMPREST,
                    cptTvaImp: data.cptTvaImp,
                    montDem: data.montDem,

                    CODOPE1: data.CODOPE1,
                    CODOPE2: data.CODOPE2,
                    CODOPE3: data.CODOPE3,
                    CODOPE4: data.CODOPE4,
                    CODOPE5: data.CODOPE5,

                    MTNCOM1: data.MTNCOM1,
                    MTNCOM2: data.MTNCOM2,
                    MTNCOM3: data.MTNCOM3,
                    MTNCOM4: data.MTNCOM4,
                    MTNCOM5: data.MTNCOM5,

                    garanties: data.garanties,
                    avaliste: data.avaliste,
                    step: '',
                    //datjour: user.datjour
                    generateNewAccount: false,
                    DateVal: data.DateVal ? (new Date(data.DateVal.substring(0, 10))).toLocaleDateString("fr") : ''
                  });
                })
                if(datat.length>0) {setDatapret(datat);}
              }
            }
             
              if (responseSix.data) {
                let dat: DataPeriodAuto[] = [];
                const res = JSON.parse(Crypter.decrypt(responseSix.data)).Value;
                if (res.StatutCode === 200) {
                  res.Result.map((val: any, key: any) => {
                      dat.push({
                          key: key,
                          NUMCRD: val.NUMCRD,
                          NUMCLI: val.NUMCLI,
                          NOMCLI: val.NOMCLI,
                          SERVGE: val.SERVGE,
                          NATCRD: val.NATCRD,
                          MNTAUT: formatNumber(val.MNTAUT),
                          DATEFF:  val.DATEFF ?(new Date(val.DATEFF.substring(0, 10))).toLocaleDateString("fr") : '',
                          DATEFIN: val.DATEFIN ?(new Date(val.DATEFIN.substring(0, 10))).toLocaleDateString("fr") : '',
                          CPTAUT:val.CPTAUT,
                          CDETAT:val.CDETAT
                  })
                 })
                 if (dat.length > 0) { setDataPeriodAuto(dat) }
                }
               }
        
               if (responseSeven.data) 
               {
                let dat: DataPeriodMVirement[] = [];
                 const res = JSON.parse(Crypter.decrypt(responseSeven.data)).Value;
                 if (res.StatutCode === 200) {
                   res.Result.map((val: any, key: any) => {
                      dat.push({
                          key: key,
                          NUMDOS: val.NUMDOS,
                          CODOPE: val.CODOPE,
                          DATSAI: val.DATSAI,
                          DATIMP: val.DATIMP,
                          CPTDEB: val.CPTDEB,
                          LIBCPTDEB: val.LIBCPTDEB,
                          CPTCRE: val.CPTCRE,
                          LIBCPTCRE: val.LIBCPTCRE,
                          MONTAN: val.MONTAN,
                          FREQIMP: val.FREQIMP,
                          NBRIMP: val.NBRIMP,
                          DECOUV: val.DECOUV,
                          DATARRIMP: val.DATARRIMP,
                          UTISAI: val.UTISAI,
                          UTIMOD: val.UTIMOD,
                          DATMOD: val.DATMOD,
                          IsFRAIS: val.IsFRAIS,
                          MONTAN1: val.MONTAN1,
                          MONTAN2: val.MONTAN2,
                          MONTAN3: val.MONTAN3,
                          MONTAN4: val.MONTAN4,
                          LIBELL1: val.LIBELL1,
                          LIBELL2: val.LIBELL2,
                          LIBELL3: val.LIBELL3,
                          LIBELL4: val.LIBELL4,
                          CODOP1: val.CODOP1,
                          CODOP2: val.CODOP2,
                          CODOP3: val.CODOP3,
                          CODOP4: val.CODOP4,
                          codage: val.codage,
                          cdetat: val.cdetat,
                          utival: val.utival,
                          isbloqAuto: val.isbloqAuto,
                          datval: val.datval
                      })
                  })
                  if (dat.length > 0) { setDataPeriodMVirement(dat) }
                
                // alert(JSON.stringify(res))
                 }}}


          )).catch((error) => {
            setLoading(false);
            SweetAlert.fire({ title: "error", text: error.message, icon: "error" });
          });
      setLoading(false);
    }
    else {
      setLoading(false);
      SweetAlert.fire({ title: "Warning", text: "Account not found", icon: "error" });
    }
  }


  const items: TabsProps['items'] = [
    {
      key: '1',
      label: (
        <span>
          <UserOutlined />
          Historique
          {/* Compte */}
        </span>
      ),
      children: <Tab1 form={form} DataHistor={DataHisto} Function={consult} />,
    },
    {
      key: '3',
      label: (
        <span>
          <ContactsOutlined />
          Signataire/Procuration
        </span>
      ),
      children: <Tab3 form={form} DataProCpt={DataProCpt} DataSingCpt={DataSingCpt} />,
    },
  //   {
  //     key: '4',
  //     label: (
  //       <span>
  //         <ContactsOutlined />
  //         Contact
  //       </span>
  //     ),
  //    // children: <Tab4 form={form} />,
  //   },
  //   {
  //     key: '5',
  //     label: (
  //       <span>
  //         <ContactsOutlined />
  //         Prét
  //       </span>
  //     ),
  //     //children: <Tab2 dataPret={dataPret} form={form} />,
  //   },
  //   {
  //     key: '6',
  //     label: (
  //       <span>
  //         <ContactsOutlined />
  //         Découvert/Facilité
  //       </span>
  //     ),
  //    // children: <Tab5 form={form}  DataPeriodAuto={DataPeriodAuto} />,
  //   },
  //   {
  //     key: '7',
  //     label: (
  //       <span>
  //         <ContactsOutlined />
  //         Montant Bloqué
  //       </span>
  //     ),
  //   //  children: <Tab7 form={form} DataMontantBloque={DataMontantBloque}></Tab7>,
  //   },
  //   {
  //     key: '8',
  //     label: (
  //       <span>
  //         <ContactsOutlined />
  //         Virement
  //         {/* Permenant */}
  //       </span>
  //     ),
  //  //   children: <Tab6  form={form}  DataPeriodAuto={DataPeriodMVirement} />,
  //   },
  ];

  //En cas d'echec aux formulaire
  const onFinishFailed = async (errorInfo: any) => {
    var errors: any = [];
    errorInfo.errorFields.map((error: any) => {
      errors.push(error.name + "");
    })
    SweetAlert.fire({ title: "Veuillez remplir tous les champs obligatoires", text: errors.toString().replaceAll(',', " - "), icon: 'warning', confirmButtonText: 'OK' })

  };


  const onFinish = async (values: any) => {

    setDataHisto([]);

      let histocpt: HistoCpt = {
        datD: (new Date(values.datD)).toLocaleDateString("fr").replaceAll('/', '-'),
        DatF: (new Date(values.DatF)).toLocaleDateString("fr").replaceAll('/', '-'),
        Utilis: user.coduti,
        Agence: form.getFieldValue("AGCCPT"),
        Numcpt:form.getFieldValue("NUMCPT"),
        TypD: '0',
        Rgpt: '0',
        Idplan: '',
        anneeEncour: user.datjour.substring(0, 4),
        isConso: '0',
      };

      setLoading(true);
      //let group = profilsDistant.find(()=>)
      //console.log('Received values of form: ', histocpt);

      let DataBody = Crypter.encrypt(JSON.stringify(histocpt));

      let config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: Data.ApiUrl.GetHistoriqueCpt,
        headers: {
          'CypherHistoCpt': DataBody,
          'Authorization': authHeader(),
          'Content-Type': 'application/json'
        }
      };

      await axios.request(config)
        .then((response) => {
          if (response.data) {
            const res = JSON.parse(Crypter.decrypt(response.data)).Value;
          
            if (res.StatutCode == 200) {
              if (res.Result.length > 0) {

                const Datat: DataHistoCpt[] = [];
                let RePorSoldeI: number = 0;
                let RePorSolde: number = 0;
                let TotalDebit: number = 0;
                let TotalCrebit: number = 0;
                let NbrCrebit: number = 0;
                let Nbrdebit: number = 0;

                form.setFieldValue("ReportSold", '');
                form.setFieldValue("TotalDebit", '');
                form.setFieldValue("TotalCrebit", '');

                RePorSoldeI = res.Result[0].MONTANTCREDIT - res.Result[0].MONTANTDEBIT;
                RePorSolde = RePorSoldeI;
                    
                res.Result.map((data: any, indice: number) => {
                  if (indice > 0) RePorSolde += data.MONTANTCREDIT - data.MONTANTDEBIT;
                  if (data.MONTANTDEBIT > 0) Nbrdebit++;
                  else NbrCrebit++;
                  //alert(data.NLIGNE )
                
                  Datat.push({
                    key: indice,
                    DATOPE: (new Date(data.DATOPE.substring(0, 10))).toLocaleDateString("fr"),
                    TIME: data.TIME,
                    DEDEVR: (new Date(data.DEDEVR.substring(0, 10))).toLocaleDateString("fr"),
                    REPECE: data.REPECE,
                    NUMRAP: data.NUMRAP,
                    LIBELL: data.LIBELL,
                    MONTANTDEBIT: formatNumber(data.MONTANTDEBIT),
                    MONTANTCREDIT: formatNumber(data.MONTANTCREDIT),
                    SOLDT: formatNumber(RePorSolde),
                    NBENEF: data.NBENEF,
                    UTISAI: data.UTISAI,
                    NLIGNE: data.NLIGNE
                  });

                  // console.log(data);
                  //Incrémentation des Montants Totaux
                  TotalDebit += data.MONTANTDEBIT;
                  TotalCrebit += data.MONTANTCREDIT;
                })
                 
                console.log(Datat);
                setDataHisto(Datat);

                SetImprimer(false);

                // form.setFieldValue("ReportSold", formatNumber(RePorSoldeI));
                form.setFieldValue("TotalDebit", formatNumber(TotalDebit));
                form.setFieldValue('TotalCrebit', formatNumber(TotalCrebit));
                form.setFieldValue("NbrCrebit", NbrCrebit);
                form.setFieldValue("Nbrdebit", Nbrdebit);
                form.setFieldValue("lastop", Datat[Datat.length - 1].DATOPE);

                localStorage.removeItem(Data.LocalVariable.tabHistCpt);

                localStorage.setItem(Data.LocalVariable.tabHistCpt, JSON.stringify({ "columns": column, "data": Datat, "form": form.getFieldsValue(),
                "Dispon": form.getFieldValue('DISPON'),"P":"H"
                // , "Dispon": ""
               }))
                // SweetAlert.fire({ title: res.Message, text: "Code : " + code, icon: "success" });
              }
              else {
                SweetAlert.fire({ title: "Oups", text: "Aucune Opération sur ce compte durant cette période", icon: "info" })
              }
            }
            else {
              SweetAlert.fire({ title: res.Message, text: res.Result, icon: "warning" })
            }
            setLoading(false);
          }
        })
        .catch((error) => {
          setLoading(false);
          console.log(error)
          SweetAlert.fire({ title: "Error", text: error, icon: "error" })
        });
    }
    
  const HandlerActualiser = () => {
    form.resetFields();
    SetNumcpt("");
    setDataCpt([]);
    setDataHisto([]);
    initialiazeButton();
  }

  const HandlerLoadTab = async () => {
    setLoading(true);
    if (form.getFieldValue("NUMCPT") !== "") {

      await consult();
    } else {
      form.setFieldsValue({'BlocSys': '', 'SOLVEI': '', 'AUTORI': '', 'SOLIN1': '', 'DISPON': '', 'TotalDebit': '', 'TotalCrebit': '' });
      setDataHisto([]);
      SetDataSingCpt([]);
      SetDataProCpt([]);
      SweetAlert.fire({ title: "Oups", text: "veuillez sélectionner un compte ", icon: "info", confirmButtonColor: "#116599", cancelButtonColor: "darkred", })
    }
    setLoading(false);
  }


  return (
    <div>
      <div className='tab'>
        <Typography align='center' className='formTitle'><b>Situation Client</b></Typography>
        <Spin spinning={loading} size='large' style={{ color: '#116599' }} >
          <Form disabled={ActiveForm} autoComplete="off" labelAlign='left' onFinish={onFinish} onFinishFailed={onFinishFailed} form={form} name="dynamic_form_complex" style={{ minWidth: 'auto', maxWidth: 'auto' }}>
            <div className='bG'>
              <legend><Typography color={"#116599"}>Actions</Typography></legend>
              <Form.Item shouldUpdate className='bouttong'>
                <Space direction="vertical" style={{ width: '100%' }}>
                  
                  <Button size='large' className='bt_add' disabled={Consulter} type="ghost" htmlType="submit" block  >
                    Consulter
                  </Button>
                  <Button size='large' className='bt_add' disabled={false} onClick={() => { HandlerActualiser() }} type="ghost" htmlType="button" block  >
                    Actualiser
                  </Button>
                  <Button size='large' disabled={Imprimer} onClick={() => {
                                      PrintHistCompteDirect(
                                        user.coduti ?? '',
                                        form.getFieldValue("AGCCPT") ?? '',
                                        Branch.agence?.LIBELLE ?? '',
                                        Branch.agence?.BANQUE ?? '',
                                        Branch.agence?.TELEPH ?? '',
                                         Branch.agence?.NUMREG ?? '',
                                         Branch.agence?.LICENCE ?? '',
                                         Branch.agence?.NUMREG ?? '',
                                         Branch.agence?.BPOSTE ?? '',
                                         Branch.agence?.VILLE ?? '',
                                        user.nomuti ?? '',
                                        form.getFieldValue("NUMCPT") ?? '',
                                        form.getFieldValue("datD") ?? '',
                                        form.getFieldValue("DatF") ?? '',
                                        "HISTORIQUE",
                                        "PDF"
                                      )
                                    }} className='bt_add' type="ghost" htmlType="button" block  >
                                      Aperçu
                                    </Button>
                  {/* <Button size='large' disabled={Imprimer} onClick={() => { navigate("/SituationClient/print/HistoriqueCpt"); }} className='bt_add' type="ghost" htmlType="button" block  >
                    Aperçu
                  </Button> */}
                </Space>
              </Form.Item>
            </div>
            <div className='clientP'>
              <div >
                <Tabs hideAdd
                 onChange={async (e) => { if (e != '1' && form.getFieldValue('NUMCPT')!== '' && typeof form.getFieldValue('NUMCPT')!=='undefined') { HandlerLoadTab(); } }} 
                 size='small' type="card" defaultActiveKey="1" items={items} />
              </div>
              <div>
              </div>
            </div>
          </Form>
        </Spin>
      </div>
    </div>
  );
}
export default Historique;